module.exports = __webpack_public_path__ + "img/Libya.200cadb3.svg";